import { useState } from 'react';
import { UseCatalogCreationAccessTableParams } from '../catalogCreationAccess.types';
import { resolveCatalogCreationAccessTableHeight } from '../catalogCreationAccess.utils';

export const useCatalogCreationAccessTable = ({
  rowCount,
  maxVisibleRows,
}: UseCatalogCreationAccessTableParams) => {
  const [scrollElement, setScrollElement] = useState<HTMLDivElement | null>(null);

  return {
    scrollElement,
    setScrollElement,
    tableHeight: resolveCatalogCreationAccessTableHeight({ rowCount, maxVisibleRows }),
  };
};
